import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { URL_MAP } from '../../shared/urlMap';
import { environment as ENV } from '../../../environments/environment';
import { SubcuentaPrograma } from '../../models/subcuenta-programa/subcuenta-programa';

@Injectable({
  providedIn: 'root',
})
export class SubcuentasProgramaService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.SUBCUENTAS_PROGRAMA}`;

  constructor(private http: HttpClient) {}

  getSubcuentasPrograma(programa: string): Observable<SubcuentaPrograma[]> {
    const body = {
      nombreClave: 'getSpSubcuentaPrograma',
      jsonParametros: JSON.stringify({
        prm_programa: programa,
      }),
    };

    return this.http.post<SubcuentaPrograma[]>(this.apiUrl, body);
  }
}
